import React from 'react';
import styles from '../../styles/Landlord/LandlordDashboardContent.module.css';

const DashboardContent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2>Overview</h2>
        <div className={styles.stats}>
          <div className={styles.stat}>
            <h3>12</h3>
            <p>Active Listings</p>
          </div>
          <div className={styles.stat}>
            <h3>4</h3>
            <p>Pending Applications</p>
          </div>
          <div className={styles.stat}>
            <h3>8</h3>
            <p>Occupied Units</p>
          </div>
        </div>
      </div>

      <div className={styles.card}>
        <h2>Quick Actions</h2>
        <div className={styles.actions}>
          <button>Add New Listing</button>
          <button>View Applications</button>
          <button>Manage Units</button>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;
